<ng-container *ngIf="!chTheme6">
<span class="contact-us-wrapper" [ngClass]="themeClass('header-contact-section1')">
  <p *ngIf="chTheme9" class="contact-text"><span>CALL</span><br/><b>US</b></p>
  <a href="tel:{{contact}}" class="btn-phone" aria-label="Call">
    <img [src]="commonImagePath+phoneImg" alt="Call" width="20" height="19" loading="lazy" />
    {{formatted_contact}}
  </a>
</span>
</ng-container>

<!-- TIRES CONT-US -->
<div class="h-contact mb-2" *ngIf="chTheme6">
  <small class="h-contact-txt-1 mb-0">support</small>
  <a class="h-contact-txt-2" href="tel:{{contact}}"> {{formatted_contact}}</a>
</div>